import script from "./register_form.vue?vue&type=script&setup=true&lang=js"
export * from "./register_form.vue?vue&type=script&setup=true&lang=js"

import "./register_form.vue?vue&type=style&index=0&id=3aea7ba4&lang=css"

const __exports__ = script;

export default __exports__